import { Post } from './Post';
import { User } from './User';

export enum PostRequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export type PostRequest = {
  id: string;
  post: Post;
  requester: User;
  reason: string;
  description: string;
  rejectedReason: string;
  status: PostRequestStatus;
  type?: 'edit' | 'delete';
  approved?: Date | string;
  created: Date;
  modified: Date;
  deleted: Date;
};
